/**
 * NextOfKinSection - Next of kin contact and address
 */

import { OathInput, OathSelect } from '../../../../shared/OathUI';
import { ACCEPT_QUOTE_FIELD_MAX_LENGTH } from '../../shared/requestFieldLimits';
import { STATE_OPTIONS } from '../../shared/usStates';
import { formatPhoneNumber, unformatPhone } from '../../shared/formatUtils';

const NextOfKinSection = ({ formState, dispatch, requiredFields }) => {
  const isRequired = (field) => requiredFields.includes(field);
  const set = (field) => (val) => dispatch({ type: 'SET_FIELD', field, value: val });

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-3">Next of Kin</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <OathInput
          label="Name"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nextOfKinName}
          value={formState.nextOfKinName}
          onChange={set('nextOfKinName')}
          placeholder="Full name"
          required={isRequired('nextOfKinName')}
        />
        <OathInput
          label="Phone"
          value={formatPhoneNumber(formState.nextOfKinPhoneNumber)}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'nextOfKinPhoneNumber', value: unformatPhone(val) })}
          placeholder="(555) 123-4567"
          required={isRequired('nextOfKinPhoneNumber')}
        />
        <div className="sm:col-span-2">
          <OathInput
            label="Street"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nextOfKinAddressStreet1}
            value={formState.nextOfKinAddressStreet1}
            onChange={set('nextOfKinAddressStreet1')}
            placeholder="Street address"
            required={isRequired('nextOfKinAddressStreet1')}
          />
        </div>
        <div className="sm:col-span-2">
          <OathInput
            label="Street 2"
            maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nextOfKinAddressStreet2}
            value={formState.nextOfKinAddressStreet2}
            onChange={set('nextOfKinAddressStreet2')}
            placeholder="Apt, suite, etc."
          />
        </div>
        <OathInput
          label="City"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nextOfKinAddressCity}
          value={formState.nextOfKinAddressCity}
          onChange={set('nextOfKinAddressCity')}
          placeholder="City"
          required={isRequired('nextOfKinAddressCity')}
        />
        <OathSelect
          label="State"
          value={formState.nextOfKinAddressState}
          onChange={set('nextOfKinAddressState')}
          options={STATE_OPTIONS}
          placeholder="Select state..."
          required={isRequired('nextOfKinAddressState')}
        />
        <OathInput
          label="Zip Code"
          maxLength={ACCEPT_QUOTE_FIELD_MAX_LENGTH.nextOfKinAddressZipCode}
          value={formState.nextOfKinAddressZipCode}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'nextOfKinAddressZipCode', value: val.replace(/\D/g, '').slice(0, 5) })}
          placeholder="12345"
          required={isRequired('nextOfKinAddressZipCode')}
        />
      </div>
    </div>
  );
};

export default NextOfKinSection;
